import { render, staticRenderFns } from "./NavigationTopbar.vue?vue&type=template&id=05bd6150&scoped=true"
import script from "./NavigationTopbar.vue?vue&type=script&lang=ts"
export * from "./NavigationTopbar.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTopbar.vue?vue&type=style&index=0&id=05bd6150&prod&lang=css"
import style1 from "./NavigationTopbar.vue?vue&type=style&index=1&id=05bd6150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd6150",
  null
  
)

export default component.exports